<template>
  <table class="detail-table">
    <tbody>
      <tr v-for="row in rows" :key="row.key">
        <td>{{ row.label }}</td>
        <td class="detail-table__value" :class="{ 'detail-table__value--muted': isMutedValue }">{{ row.value }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'DetailTable',
  props: {
    rows: {
      type: Array,
      required: true
    },
    isMutedValue: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.detail-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--font-base);
  font-variant-numeric: tabular-nums;
}

.detail-table td {
  padding: 8px 0;
  border-bottom: 1px solid var(--line);
}


.detail-table td {
  color: var(--text-strong);
}

.detail-table__value {
  text-align: right;
  white-space: nowrap;
}

.detail-table td.detail-table__value--muted {
  color: var(--text-muted);
}
</style>
